import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { SettingsComponent } from '../../component/user/settings/settings.component';
import { EbUser } from '../../classes/user';
import { CompagnieService } from '../../services/compagnie.service';
import { EbLien } from '../../classes/lien';
import { Router } from '@angular/router';
import { EbCompagnie } from '../../classes/compagnie';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	constructor(
		protected authenticationService: AuthenticationService,
		private compagnieService: CompagnieService,
		private router: Router,
	) {
	}

	ngOnInit() {
		/*this.authenticationService.isLoggedInObservable.subscribe ( (isAuthenticated) => 
		{
			console.log("je suis dans homecomponent isAuthenticated = ");
			console.log(isAuthenticated);
		});*/
		let compNum;
		const compagnie: EbCompagnie  = AuthenticationService.getConnectedUser().ebCompagnie;
		
		if(compagnie!=null) {
			if (typeof compagnie == 'number') {
				compNum = compagnie;
			}
			else {
				compNum = compagnie.ebCompagnieNum;
			}
			this.compagnieService.getListLienCompagnie(compNum).subscribe((data: Array<EbLien>) => {
	
	
				if (data != null && data.length != 0) {
					this.router.navigate(['/app/dashboard']);
				}
			})
		}


	}

}



// WEBPACK FOOTER //
// ./src/app/corp/home/home.component.ts